<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    @if(!processing()){
      @if(alert){
        <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
      }
      @let tmplCurrentGameRound = currentGameRound();      
      @if(pool && poolPoule){
        <div class="d-flex justify-content-{{poolPoule ? 'between' : 'center'}} mt-2">
            <h2 class="ms-3" ngClass="{'pointer': pool}" (click)="navigateToStructure()">
              <app-superelf-icon [icon]="leagueName === Cup ? facCup : facSuperCup"></app-superelf-icon>
              <span class="">{{nameService.getLeagueName(leagueName)}}</span>
              <span> - </span>
              <span class="small ms-1" [innerHTML]="structureNameService.getRoundName(poolPoule.getRound(), true) | keepHtml"></span>
            </h2>
            <div>                 
              <button (click)="navigateToChat(pool,poolPoule)" type="button"
                  class="btn btn-outline-dark me-3 position-relative">
                  <fa-icon [icon]=faMessage></fa-icon>
                  <span class="ms-1"> chat</span>
                  @if(nrOfUnreadMessages > 0) {
                    <span
                        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {{nrOfUnreadMessages}}
                        <span class="visually-hidden">ongelezen berichten</span>
                    </span>
                  }
              </button>
            </div>
        </div>
      }

      @let tmplHome = homeItem();
      @let tmplAway = awayItem();      
      @if(pool && tmplCurrentGameRound && poolPoule && tmplHome && tmplAway) {
        <div>          
         
          @if( !processingGames() && !processingStatistics()) {

            <div class="d-flex justify-content-center mt-3">
              <app-title-againstgame-pool 
                [poolPoule]="poolPoule"
                [homeCompetitorPoolUserAndFormation]="tmplHome"
                [awayCompetitorPoolUserAndFormation]="tmplAway"
                [viewPeriod]="tmplCurrentGameRound.viewPeriod"
                [gameRounds]="viewGameRounds()"
                [activeGameRound]="tmplCurrentGameRound"
                [competitionConfig]="pool.getCompetitionConfig()"
                (selectGameRound)="currentGameRound.set($event)"
                [statisticsGetter]="statisticsGetter">
              </app-title-againstgame-pool>              
            </div>
            
            @if(pool && tmplCurrentGameRound && sourceGameRoundGames.length > 0){
              <div class="mt-3">                
                <againstgames-table
                  [sourceAgainstGames]="sourceGameRoundGames"
                  [gameRound]="tmplCurrentGameRound"
                  [competitorPoolUserAndFormations]="[tmplHome,tmplAway]"
                  [statisticsGetter]="statisticsGetter">
                </againstgames-table>
              </div>
            }
          } @else {
            <h2 class="text-center">
                <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
            </h2>
          }
        </div>
      }
    }
    @else {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    </div>
</div>


@if(!processing() && pool){
  <app-pool-navbar [current]="ActiveNavItem" [pool]="pool" [poolUser]="poolUserFromSession"></app-pool-navbar>  
}

 <!-- Start      PlayerName, Team And Line -->
<ng-template #contentForamtionPlace let-formationPlace="formationPlace" let-away="away">
    @if( formationPlace ){
        <div class="d-flex align-items-start" ngClass="{'flex-row-reverse': away}">
            @if(formationPlace.getPlayer()){
            <app-lineicon [line]="formationPlace.getPlayer().getLine()">
            </app-lineicon>
            }
            <ng-container *ngTemplateOutlet="contentPlayer; context: {s11Player:formationPlace.getPlayer()}">
            </ng-container>
            @if(formationPlace.isSubstitute()){
              <span class="badge badge-reserve">r</span>
            }
        </div>
    }
</ng-template> <!-- End      PlayerName, Team And Line -->

<!-- Start      PlayerScore -->
<!-- <ng-template #contentForamtionPlaceScore let-formationPlace="formationPlace" let-sourceGame="sourceGame" let-gameRound="gameRound">
    @if(formationPlace){

        @if(!formationPlace.isSubstitute()){
            @if(sourceGame.getState() === Finished) {
                <ng-container *ngTemplateOutlet="lineupScore; context: {formationPlace, sourceGame, gameRound: gameRound}">
                </ng-container>
            }
        } @else {
            @if(gameRound && statisticsGetter.areStartingPlacesFinished(formationPlace.getFormationLine(),gameRound)){
            
                @if(formationPlace.getFormationLine().hasSubstituteAppareance(gameRound)){
                    @if(sourceGame.getState() === Finished){
                    <ng-container *ngTemplateOutlet="lineupScore; context: {formationPlace, sourceGame, gameRound}">
                    </ng-container>
                    }
            
                }@else {
                    <span class="badge text-bg-danger">
                        <a [routerLink]="['/pool/sourcegame', pool.getId(), sourceGame.getGameRoundNumber(), sourceGame.getId()]">
                            &nbsp;
                        </a>
                    </span>
                }
            }
        }
    }
</ng-template>  -->
<!-- End      PlayerScore -->

<ng-template #contentPlayer let-s11Player="s11Player">
  @if(s11Player !== undefined){
    <span class="mx-1 text-break">{{s11Player.getPerson().getName()}}</span>
  }
</ng-template>


<!-- <ng-template #lineupScore let-formationPlace="formationPlace" let-sourceGame="sourceGame" let-gameRound="gameRound">
    @if(statisticsGetter.hasAppeared(formationPlace,gameRound)) {
        <span class="badge bg-points">
            <a [routerLink]="['/pool/sourcegame', pool.getId(), sourceGame.getGameRoundNumber(), sourceGame.getId()]">
                @if(gameRound){
                <span>
                    {{statisticsGetter.getFormationPlaceGameRoundPoints(formationPlace,gameRound, undefined)}}
                </span>
                }
            </a>
        </span>
    } @else {
        <button type="button" class="btn btn-sm btn-notappeared">&nbsp;</button>
    }
</ng-template> -->